export default {
  props: {
    pageLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    delayTime: {
      type: Number,
      required: false,
      default: 200,
    },
  },
  methods: {
    // toTop组件参考dom
    topTarget() {
      return document.querySelector('#content');
    },
  },
};
